var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 40,
    viewBox: "0 0 56 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 40,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1092,
    transform: "translate(-773 -416)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: -773,
    y: -416,
    width: 1600,
    height: 3577,
    fill: "#F2EEF8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_344_0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_344_0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -476.998,
    y: -220,
    width: 1264,
    height: 278,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8594 7.48633C60.3516 7.48633 60.8174 7.58008 61.2568 7.76758C61.6963 7.94922 62.0771 8.2041 62.3994 8.53223C62.7217 8.85449 62.9795 9.22949 63.1729 9.65723C63.3662 10.0791 63.4629 10.5244 63.4629 10.9932C63.4629 11.4619 63.3662 11.9102 63.1729 12.3379C62.9795 12.7598 62.7217 13.1348 62.3994 13.4629C62.0771 13.7852 61.6963 14.04 61.2568 14.2275C60.8174 14.4092 60.3516 14.5 59.8594 14.5H57.4336V18.8242H55.9922V7.48633H59.8594ZM59.8594 13.2432C60.1465 13.2432 60.4219 13.1875 60.6855 13.0762C60.9492 12.959 61.1807 12.8008 61.3799 12.6016C61.5791 12.3965 61.7344 12.1562 61.8457 11.8809C61.9629 11.5996 62.0215 11.3037 62.0215 10.9932C62.0215 10.6826 61.9629 10.3896 61.8457 10.1143C61.7344 9.83887 61.5791 9.59863 61.3799 9.39355C61.1807 9.18848 60.9492 9.03027 60.6855 8.91895C60.4219 8.80176 60.1465 8.74316 59.8594 8.74316H57.4336V13.2432H59.8594ZM68.0354 10.6328C68.4807 10.6328 68.8908 10.709 69.2658 10.8613C69.6467 11.0078 69.9719 11.207 70.2414 11.459C70.5109 11.7109 70.7189 12.0068 70.8654 12.3467C71.0178 12.6807 71.0939 13.041 71.0939 13.4277V18.8242H70.1096L69.7492 17.9277C69.5676 18.1211 69.3625 18.2881 69.134 18.4287C68.9289 18.5635 68.677 18.6777 68.3781 18.7715C68.0793 18.8652 67.7248 18.9121 67.3146 18.9121C66.9045 18.9121 66.5354 18.8506 66.2072 18.7275C65.8791 18.5986 65.5979 18.4229 65.3635 18.2002C65.1291 17.9775 64.9445 17.7197 64.8098 17.4268C64.6809 17.1338 64.6164 16.8203 64.6164 16.4863C64.6164 16.0996 64.6926 15.748 64.8449 15.4316C65.0031 15.1152 65.2727 14.8398 65.6535 14.6055C66.0402 14.3711 66.5676 14.1924 67.2355 14.0693C67.9035 13.9404 68.7414 13.876 69.7492 13.876V13.4277C69.7492 13.0176 69.5881 12.6602 69.2658 12.3555C68.9494 12.0508 68.5393 11.8984 68.0354 11.8984C67.5314 11.8984 67.1594 12.0039 66.9191 12.2148C66.6789 12.4199 66.5119 12.7041 66.4182 13.0674H64.9768C65.0236 12.7334 65.1262 12.4199 65.2844 12.127C65.4426 11.8281 65.6506 11.5674 65.9084 11.3447C66.1662 11.1221 66.4709 10.9492 66.8225 10.8262C67.174 10.6973 67.5783 10.6328 68.0354 10.6328ZM67.3146 17.6553C67.6721 17.6553 68.0002 17.5996 68.299 17.4883C68.6037 17.3711 68.8615 17.2246 69.0725 17.0488C69.2834 16.8672 69.4475 16.665 69.5646 16.4424C69.6877 16.2197 69.7492 15.9941 69.7492 15.7656V15.1328C68.9348 15.1328 68.2814 15.168 67.7893 15.2383C67.2971 15.3027 66.9133 15.3994 66.6379 15.5283C66.3684 15.6514 66.1896 15.8008 66.1018 15.9766C66.0139 16.1465 65.9699 16.3457 65.9699 16.5742C65.9699 16.8496 66.09 17.0986 66.3303 17.3213C66.5764 17.5439 66.9045 17.6553 67.3146 17.6553ZM72.1508 10.7207H73.5922L76.0268 16.9346L78.4525 10.7207H79.8939L76.3871 19.5449C76.0648 20.3594 75.725 20.9365 75.3676 21.2764C75.016 21.6221 74.5766 21.7949 74.0492 21.7949C73.9789 21.7949 73.9115 21.792 73.8471 21.7861C73.7885 21.7803 73.7299 21.7715 73.6713 21.7598C73.6127 21.748 73.557 21.7305 73.5043 21.707V20.626C73.9145 20.626 74.2191 20.5352 74.4184 20.3535C74.6234 20.1719 74.7992 19.9023 74.9457 19.5449L75.3061 18.6484L72.1508 10.7207ZM81.8561 14.7725C81.8561 15.2061 81.9205 15.6016 82.0494 15.959C82.1842 16.3105 82.3658 16.6123 82.5943 16.8643C82.8229 17.1162 83.0836 17.3125 83.3766 17.4531C83.6754 17.5879 83.9801 17.6553 84.2906 17.6553C84.6012 17.6553 84.9029 17.5879 85.1959 17.4531C85.4889 17.3125 85.7467 17.1162 85.9693 16.8643C86.192 16.6123 86.3707 16.3105 86.5055 15.959C86.6461 15.6016 86.7164 15.2061 86.7164 14.7725C86.7164 14.3389 86.6461 13.9463 86.5055 13.5947C86.3707 13.2432 86.192 12.9414 85.9693 12.6895C85.7467 12.4375 85.4889 12.2441 85.1959 12.1094C84.9029 11.9688 84.6012 11.8984 84.2906 11.8984C83.9801 11.8984 83.6754 11.9688 83.3766 12.1094C83.0836 12.2441 82.8229 12.4375 82.5943 12.6895C82.3658 12.9414 82.1842 13.2432 82.0494 13.5947C81.9205 13.9463 81.8561 14.3389 81.8561 14.7725ZM88.0699 14.7725C88.0699 15.3818 87.9703 15.9414 87.7711 16.4512C87.5719 16.9551 87.3023 17.3916 86.9625 17.7607C86.6227 18.124 86.2213 18.4082 85.7584 18.6133C85.2955 18.8125 84.8062 18.9121 84.2906 18.9121C83.775 18.9121 83.2857 18.8125 82.8229 18.6133C82.36 18.4082 81.9557 18.124 81.61 17.7607C81.2701 17.3916 81.0006 16.9551 80.8014 16.4512C80.608 15.9473 80.5113 15.3877 80.5113 14.7725C80.5113 14.1631 80.608 13.6064 80.8014 13.1025C81.0006 12.5986 81.2701 12.165 81.61 11.8018C81.9557 11.4326 82.36 11.1455 82.8229 10.9404C83.2857 10.7354 83.775 10.6328 84.2906 10.6328C84.8062 10.6328 85.2955 10.7354 85.7584 10.9404C86.2213 11.1455 86.6227 11.4326 86.9625 11.8018C87.3023 12.165 87.5719 12.5986 87.7711 13.1025C87.9703 13.6064 88.0699 14.1631 88.0699 14.7725ZM92.827 18.9121C92.3934 18.9121 91.9861 18.8271 91.6053 18.6572C91.2303 18.4814 90.8963 18.2412 90.6033 17.9365C90.3162 17.626 90.0877 17.2568 89.9178 16.8291C89.7537 16.3955 89.6717 15.9209 89.6717 15.4053V10.7207H91.0252V15.4053C91.0252 15.7393 91.075 16.0439 91.1746 16.3193C91.2801 16.5947 91.4207 16.832 91.5965 17.0312C91.7781 17.2305 91.9891 17.3857 92.2293 17.4971C92.4695 17.6025 92.7273 17.6553 93.0027 17.6553C93.6414 17.6553 94.16 17.4531 94.5584 17.0488C94.9627 16.6387 95.1648 16.0908 95.1648 15.4053V10.7207H96.5096V18.8242H95.5252L95.1648 17.9277C94.9949 18.1211 94.7957 18.2881 94.5672 18.4287C94.3621 18.5635 94.116 18.6777 93.8289 18.7715C93.5477 18.8652 93.2137 18.9121 92.827 18.9121ZM99.4561 8.56738H100.625V10.7207H102.427V11.9863H100.625V16.2139C100.625 16.6709 100.748 17.0254 100.994 17.2773C101.24 17.5293 101.568 17.6553 101.979 17.6553C102.096 17.6553 102.204 17.6436 102.304 17.6201C102.351 17.6084 102.392 17.5908 102.427 17.5674V18.7363C102.368 18.7715 102.304 18.8008 102.233 18.8242C102.075 18.8828 101.87 18.9121 101.618 18.9121C101.308 18.9121 101.012 18.8477 100.73 18.7188C100.449 18.584 100.2 18.3994 99.9834 18.165C99.7666 17.9307 99.5938 17.6494 99.4648 17.3213C99.3418 16.9932 99.2803 16.624 99.2803 16.2139V11.9863H97.8389V10.7207H98.4717C99.1338 10.7207 99.4619 10.3926 99.4561 9.73633V8.56738ZM109.346 16.4863C109.346 16.8203 109.279 17.1338 109.144 17.4268C109.015 17.7197 108.83 17.9775 108.59 18.2002C108.35 18.4229 108.06 18.5986 107.72 18.7275C107.38 18.8506 106.993 18.9121 106.56 18.9121C105.657 18.9121 104.948 18.6719 104.433 18.1914C103.917 17.7109 103.636 17.1133 103.589 16.3984H104.943C104.989 16.7559 105.145 17.0547 105.408 17.2949C105.672 17.5352 106.056 17.6553 106.56 17.6553C107.017 17.6553 107.371 17.5381 107.623 17.3037C107.875 17.0693 108.001 16.7969 108.001 16.4863C108.001 16.1875 107.896 15.9619 107.685 15.8096C107.474 15.6572 107.213 15.5371 106.903 15.4492C106.592 15.3613 106.252 15.2793 105.883 15.2031C105.52 15.1211 105.18 15.0039 104.863 14.8516C104.553 14.6934 104.292 14.4707 104.081 14.1836C103.87 13.8906 103.765 13.4863 103.765 12.9707C103.765 12.6602 103.829 12.3643 103.958 12.083C104.093 11.8018 104.278 11.5527 104.512 11.3359C104.746 11.1191 105.028 10.9492 105.356 10.8262C105.69 10.6973 106.062 10.6328 106.472 10.6328C107.333 10.6328 108.001 10.8584 108.476 11.3096C108.95 11.7607 109.211 12.3467 109.258 13.0674H107.904C107.858 12.71 107.72 12.4258 107.491 12.2148C107.263 12.0039 106.923 11.8984 106.472 11.8984C106.062 11.8984 105.734 12.0098 105.487 12.2324C105.241 12.4492 105.118 12.6953 105.118 12.9707C105.118 13.2695 105.224 13.4951 105.435 13.6475C105.646 13.7998 105.906 13.9229 106.217 14.0166C106.528 14.1045 106.864 14.1865 107.228 14.2627C107.597 14.3389 107.937 14.4561 108.247 14.6143C108.564 14.7666 108.824 14.9922 109.029 15.291C109.24 15.584 109.346 15.9824 109.346 16.4863Z",
    fill: "#6F6C99"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -476.498,
    y: -219.5,
    width: 1263,
    height: 277,
    rx: 19.5,
    stroke: "#D9DEE7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_344_0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -773,
    y: -416,
    width: 1600,
    height: 1094,
    fill: "black",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-229 -77H284V345C284 353.837 276.837 361 268 361H-213C-221.837 361 -229 353.837 -229 345V-77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -197,
    y: -37,
    width: 449,
    height: 246,
    rx: 12,
    fill: "#CAD1E1",
    fillOpacity: 0.05,
    stroke: "#C0C3C6",
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3327 32.3333L27.9993 23L18.666 32.3333",
    stroke: "url(#paint0_linear_344_0)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 23V44",
    stroke: "url(#paint1_linear_344_0)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.578 37.9101C49.8538 36.6694 51.6516 34.7062 52.6877 32.3303C53.7238 29.9543 53.9392 27.301 53.2999 24.7891C52.6605 22.2771 51.2028 20.0497 49.1569 18.4582C47.111 16.8667 44.5934 16.0018 42.0014 16.0001H39.0614C38.3551 13.2684 37.0387 10.7322 35.2112 8.58244C33.3838 6.43265 31.0927 4.72511 28.5103 3.58821C25.9279 2.45131 23.1213 1.91463 20.3016 2.01852C17.482 2.12241 14.7225 2.86416 12.2308 4.18801C9.73904 5.51186 7.57983 7.38337 5.91549 9.66182C4.25115 11.9403 3.12498 14.5664 2.62166 17.3427C2.11833 20.119 2.25095 22.9734 3.00954 25.6911C3.76812 28.4088 5.13294 30.9191 7.00137 33.0335",
    stroke: "url(#paint2_linear_344_0)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3327 32.3333L27.9993 23L18.666 32.3333",
    stroke: "url(#paint3_linear_344_0)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_344_0",
    x: -508.998,
    y: -246,
    width: 1328,
    height: 342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_344_0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_344_0",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_344_0",
    x: -785.661,
    y: -428.661,
    width: 1625.32,
    height: 1119.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6.33067
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_344_0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_344_0",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_0",
    x1: 20.0055,
    y1: 20.75,
    x2: 37.2694,
    y2: 24.1872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_0",
    x1: 28.0718,
    y1: 17.9375,
    x2: 29.0332,
    y2: 17.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_344_0",
    x1: 6.00625,
    y1: -6.64963,
    x2: 54.3881,
    y2: 0.237152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_344_0",
    x1: 20.0055,
    y1: 20.75,
    x2: 37.2694,
    y2: 24.1872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1092,
    fill: "white",
    transform: "translate(-773 -416)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_344_0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -476.998,
    y: -220,
    width: 1264,
    height: 278,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c550c9de2e26453903f0d936ec738024.svg";
export { ForwardRef as ReactComponent };